import { useEffect } from 'react'

export const useBeforeUnload = (conditions: boolean[]) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (conditions.some((condition) => condition)) {
        const message = 'In progress'
        event.returnValue = message // Standard for most browsers
        return message // For some older browsers
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, conditions)
}
